<template>
  <div id="main-content" class="file_manager">
    <div class="container-fluid" style="height: calc(100vh - 90px)">
      <div class="block-header">
        <bread-crumb></bread-crumb>
      </div>

      <div
        class="card col-12 canfield d-flex justify-content-start align-items-center h-auto"
      >
        <div
          class="w-100 mx-auto p-2 mt-3"
          style="width: 100%; max-height: 70vh; overflow-y: auto"
        >
          <!-- Create Patient Button -->
          <div class="d-flex justify-content-start mb-3">
            <button
              class="btn create-patient-btn"
              @click="showPatientModal = true"
            >
              Create a New Subject
            </button>
          </div>

          <!-- Header Row -->
          <div class="row align-items-center mb-3 reduced-spacing">
            <div class="col-md-3 col-12">
              <h5 class="mt-3 font-weight-bold">Subjects List</h5>
            </div>

            <div class="col-md-9 col-12">
              <div class="row reduced-spacing d-flex justify-content-md-end">
                <!-- Search Bar -->
                <div class="col-md-4 px-1">
                  <div class="position-relative">
                    <input
                      type="text"
                      class="form-control search-input"
                      placeholder="Search here..."
                      v-model="searchQuery"
                    />
                    <i class="fa fa-search search-icon-left"></i>
                  </div>
                </div>

                <!-- Gender Filter -->
                <div class="col-md-2 px-1">
                  <div class="position-relative">
                    <select v-model="selectedGender" class="form-control">
                      <option value="">Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                    <i class="fa fa-user filter-icon-left"></i>
                  </div>
                </div>

                <!-- Ethnicity Filter -->
                <div class="col-md-2 px-1">
                  <div class="position-relative">
                    <select v-model="selectedEthnicity" class="form-control">
                      <option value="">Ethnicity</option>
                      <option value="CAUC">Caucasian</option>
                      <option value="CAPEC">African-American</option>
                    </select>
                    <i class="fa fa-users filter-icon-left"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Success Message -->
          <div v-if="showPatientSuccessMessage" class="alert alert-success">
            <i class="fa fa-info-circle"></i
            ><span class="mx-2">{{ successMessage }}</span>
          </div>

          <!-- Delete Success Message -->
          <div v-if="DeleteSuccessMessage" class="alert alert-success">
            <i class="fa fa-info-circle"></i> {{ DeleteSuccessMessage }}
          </div>

          <!-- Delete Confirmation Modal -->
          <div v-if="showDeletePopup" class="popup-overlay">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-headerDelete">
                  <h5 class="title" id="largeModalLabel">Confirm delete</h5>
                </div>
                <div class="modal-body">
                  Are you sure you want to delete this subject?
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="confirmDelete"
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="closeDeleteModal"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Patient Table -->
          <div v-if="!loading && filteredPatients.length">
            <table class="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>Subject ID</th>
                  <th>Name</th>
                  <th>Ethnicity</th>
                  <th>Date of Birth</th>
                  <th>Gender</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="patient in filteredPatients"
                  :key="patient.id"
                  class="clickable-row"
                >
                  <td @click="selectPatient(patient)">
                    {{ patient.patient_identifier }}
                  </td>
                  <td @click="selectPatient(patient)">
                    {{ displayName(patient.name) }}
                    {{ displayName(patient.surname) }}
                  </td>
                  <td @click="selectPatient(patient)">
                    {{ patient.ethnicity }}
                  </td>
                  <td @click="selectPatient(patient)">{{ patient.dob }}</td>
                  <td @click="selectPatient(patient)">{{ patient.sex }}</td>
                  <td style="width: 60px">
                    <i
                      class="fa fa-trash delete-icon ml-2"
                      @click.stop="openDeleteModal(patient.id)"
                      title="Delete"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="!loading && !filteredPatients.length">
            No patients found.
          </div>
        </div>
      </div>

      <!-- Patient Form Modal -->
      <div v-if="showPatientModal" class="patient-modal">
        <div class="modal-contentPatientbtn">
          <button class="close-modal-btn" @click="closePatientModal">
            &times;
          </button>
          <div>
            <h4 class="modal-header">Create a New Subject</h4>
            <!-- Patient Form -->
            <div class="patient-form">
              <form @submit.prevent="submitPatientForm" class="w-100 p-3">
                <div class="form-row">
                  <div class="form-group col-12">
                    <label for="subjectID">Subject ID:*</label>
                    <input
                      type="text"
                      id="subjectID"
                      v-model="patientForm.patient_identifier"
                      class="form-control"
                      placeholder="Subject ID"
                      required
                    />
                  </div>
                </div>
                <div v-if="subjectIdError" class="invalid-feedback mb-1" style="display:block; font-size: 12px; margin-top: -10px;">
                  {{ subjectIdError }}
                </div>

                <div class="form-row">
                  <div class="form-group col-12 col-md-6">
                    <label for="lastName">Last Name:</label>
                    <input
                      type="text"
                      id="lastName"
                      v-model="patientForm.surname"
                      class="form-control"
                      placeholder="Last Name"
                    />
                  </div>
                  <div class="form-group col-12 col-md-6">
                    <label for="firstName">First Name:</label>
                    <input
                      type="text"
                      id="firstName"
                      v-model="patientForm.name"
                      class="form-control"
                      placeholder="First Name"
                    />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="ethnicity">Subject Ethnicity:*</label>
                    <select
                      id="ethnicity"
                      v-model="patientForm.ethnicity"
                      class="form-control pr-2"
                      required
                    >
                      <option value="" disabled>Select Ethnicity</option>
                      <option value="CAUC" class="custom-option">CAUC</option>
                      <option value="CAPEC" class="custom-option">CAPEC</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="dob">Date of Birth:*</label>
                    <input
                      type="date"
                      id="dob"
                      v-model="patientForm.dob"
                      :max="todayDate"
                      class="form-control"
                      required
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label>Sex:*</label>
                  <div></div>
                  <label class="fancy-radio"
                    ><input
                      name="gender4"
                      value="male"
                      type="radio"
                      v-model="patientForm.sex"
                      required
                    /><span><i></i>Male</span></label
                  >
                  <label class="fancy-radio"
                    ><input
                      name="gender4"
                      value="female"
                      type="radio"
                      v-model="patientForm.sex"
                      required
                    /><span><i></i>Female</span></label
                  >
                </div>
                <button type="submit" class="btn custom-submit-btn">
                  Create New Subject
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";

export default {
  name: "PatientComponent",
  components: {
    BreadCrumb,
  },

  data() {
    return {
      showPatientModal: false,
      patientForm: {
        name: "",
        surname: "",
        ethnicity: "",
        patient_identifier: "",
        dob: "",
        sex: "",
        owner: 0,
      },
      patients: [],
      loading: false,
      subjectIdError: "",
      isSubmitting: false,
      searchQuery: "",
      selectedGender: "",
      selectedEthnicity: "",
      DeleteSuccessMessage: "",
      selectedPatient: {},
      token: localStorage.getItem("userJWtoken"),
      fasdBackendURL: localStorage.getItem("fasdBackendURL"),
      showDeletePopup: false,
      patientToDelete: null,
      showPatientSuccessMessage: false,
    };
  },
  created() {
    this.fetchPatients();
  },
  computed: {
    existingSubjectIds() {
      const norm = (s) => (s ?? "").toString().trim().toLowerCase();
      return new Set(this.patients.map((p) => norm(p.patient_identifier)));
    },
    filteredPatients() {
      const query = (this.searchQuery || "").toLowerCase();
      if (!Array.isArray(this.patients) || !this.patients.length) return [];

      return this.patients.filter((patient) => {
        const name = (patient.name || "").toLowerCase();
        const surname = (patient.surname || "").toLowerCase();
        const code = (patient.patient_code || "").toLowerCase();

        const nameMatch = name.includes(query) || surname.includes(query);
        const idMatch = String(patient.id || "").includes(query);
        const codeMatch = code.includes(query);

        const genderMatch = this.selectedGender
          ? patient.sex === this.selectedGender
          : true;
        const ethnicityMatch = this.selectedEthnicity
          ? patient.ethnicity === this.selectedEthnicity
          : true;

        return (
          (nameMatch || idMatch || codeMatch) && genderMatch && ethnicityMatch
        );
      });
    },
  },
  methods: {
    normSubjectId(s) {
      return (s ?? "").toString().trim().toLowerCase();
    },
    validateSubjectId() {
      const id = this.patientForm.patient_identifier || "";
      const normalized = this.normSubjectId(id);
      if (!normalized) {
        this.subjectIdError = "Subject ID is required.";
        return false;
      }
      if (this.existingSubjectIds.has(normalized)) {
        this.subjectIdError = "A subject with this Id already exists!";
        return false;
      }
      this.subjectIdError = "";
      return true;
    },
    closePatientModal() {
      this.showPatientModal = false;
    },
    async submitPatientForm() {
      if (!this.validateSubjectId()) return;
      this.isSubmitting = true;
      const fasdBackendURL =
        localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
      const url = `${fasdBackendURL}/api/patients`;
      const token = localStorage.getItem("userJWtoken");

      const new_patient = {
        name: this.patientForm.name?.trim() || "N/A",
        surname: this.patientForm.surname?.trim() || "N/A",
        ethnicity: this.patientForm.ethnicity,
        dob: this.patientForm.dob,
        sex: this.patientForm.sex,
        patient_identifier: this.patientForm.patient_identifier.trim(),
        owner: this.patientForm.owner,
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ new_patient }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        this.patients.push({
          name: this.patientForm.name?.trim() || null,
          surname: this.patientForm.surname?.trim() || null,
          ethnicity: this.patientForm.ethnicity,
          dob: this.patientForm.dob,
          sex: this.patientForm.sex,
          id: result.id,
          patient_identifier:
            result.patient_identifier ?? new_patient.patient_identifier,
          patient_code: result.patient_code,
        });

        // Clear the form data
        this.patientForm = {
          name: "",
          surname: "",
          ethnicity: "",
          dob: "",
          sex: "",
          patient_identifier: "",
          owner: 0,
        };

        this.showPatientModal = false;

        this.$router.push({
          name: "PatientDetails",
          params: { patientId: result.id },
        });

        return;
      } catch (error) {
        console.error("There was an error adding the patient:", error);
      } finally {
        this.isSubmitting = false;
      }
    },

    openDeleteModal(patientId) {
      this.showDeletePopup = true;
      this.patientToDelete = patientId;
    },
    closeDeleteModal() {
      this.showDeletePopup = false;
      this.patientToDelete = null;
    },
    async confirmDelete() {
      if (this.patientToDelete) {
        await this.deletePatient(this.patientToDelete);
        this.closeDeleteModal();
      }
    },
    selectPatient(patient) {
      this.$router.push({
        name: "PatientDetails",
        params: {
          patientId: patient.id,
        },
      });
    },

    capitalize(str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    async deletePatient(patientId) {
      try {
        const response = await fetch(
          `${this.fasdBackendURL}/api/patients/${patientId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.patients = this.patients.filter(
          (patient) => patient.id !== patientId
        );

        this.DeleteSuccessMessage = "Patient successfully deleted";

        setTimeout(() => {
          this.DeleteSuccessMessage = "";
        }, 3000);
      } catch (error) {
        console.error("Error deleting patient:", error);
      }
    },
    async fetchPatients() {
      this.loading = true;
      try {
        const response = await fetch(`${this.fasdBackendURL}/api/patients/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Patients data:", data);
        this.patients = data;
      } catch (error) {
        console.error("Error fetching patients:", error);
      } finally {
        this.loading = false;
      }
    },
    displayName(val) {
      const s = (val ?? "").toString().trim();
      if (!s) return "N/A";
      return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    },
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.table-bordered {
  border: 2px solid #ddddddd7 !important;
  border-radius: 7px !important;
  overflow: hidden;
}

th,
td {
  padding: 12px 15px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  background-color: #004ead;
  color: white;
  font-weight: bold;
  text-align: center;
}

td {
  white-space: nowrap;
}

tr:hover {
  background-color: #f5f5f5;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.edit-icon {
  cursor: pointer;
  font-size: 16px;
}

.edit-icon {
  color: #007bffd9;
}

.ml-2 {
  margin-left: 8px;
}

.position-relative {
  position: relative;
}
.reduced-spacing .col-md-4,
.reduced-spacing .col-md-3,
.reduced-spacing .col-md-2 {
  padding-left: 5px;
  padding-right: 5px;
}
.reduced-spacing {
  margin-left: -5px;
  margin-right: -5px;
}
.search-input,
.form-control {
  padding-left: 27px;
  border-radius: 10px;
  height: 36px;
}

.search-icon-left,
.filter-icon-left {
  position: absolute;
  left: 2px;
  top: 7%;
  transform: translateY(-50%);
  color: #007bff;
  pointer-events: none;
}

td.text-center {
  text-align: center;
}

@media (max-width: 767px) {
  .row.align-items-center {
    flex-direction: column;
    text-align: center;
  }

  table th,
  table td {
    font-size: 12px;
  }

  .search-input,
  .form-control {
    margin-bottom: 10px;
  }
}

.ml-2 {
  margin-left: 8px;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #9bcdf9;
}
.delete-icon {
  cursor: pointer;
  color: #e74d3cdf;
  font-size: 12px;
}

.delete-icon:hover {
  color: #c0392b;
}
.alert-success {
  margin-top: 10px;
  border: 1px solid #d4edda;
  background-color: #d4edda;
  color: #155724;
  border-radius: 5px;
  width: 80%;
  margin-left: -1px;
}
.create-patient-btn {
  background-color: #2bc551;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 50px;
  width: 180px;
  font-weight: bold;
}

.create-patient-btn:hover {
  background-color: #249b47;
}

.create-patient-btn:focus {
  outline: none;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}
.patient-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-contentPatientbtn {
  background: white;
  border-radius: 10px;
  padding: 20px;
  width: 80%;
  max-width: 800px;
  position: relative;
}

.close-modal-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
.modal-header {
  font-size: 22px;
  color: #004ead;
}
.close-modal-btn:hover {
  color: red;
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Patient Delete Modal */
.modal-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.modal-content {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 500px;
}
.modal-headerDelete {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.modal-body {
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
}
.modal-footer {
  display: flex;
  justify-content: start;
  gap: 10px;
}
.btn {
  padding: 8px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-primary {
  background-color: #007bff;
  color: #fff;
  border: none;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-danger {
  background-color: #dc3545;
  color: #fff;
  border: none;
}

.btn-danger:hover {
  background-color: #a71d2a;
}
/* Responsive */
@media (max-width: 768px) {
  .popup {
    width: 90%;
    padding: 15px;
  }
}
</style>
